import React, { useState, useEffect } from "react";
import { Menu, X, Mail, Phone } from "lucide-react";
import "./HomePage.css";
import { useNavigate, useLocation } from "react-router-dom";
import image4 from "../assets/Home/aggallery-white.png";
import HomeVideo from "../assets/Home/videoAGgallery.mp4";

const itemsArtistas = [
  "Un mes de exposición",
  "Puedes asegurar tu espacio varios meses y con ello rotación de obras",
  "Tu pago incluye servicio de resguardo dentro de la plaza comercial",
  "El costo es de $1,250 MXN por obra (aplican restricciones a obras XL)",
  "Servicio de guía y atención personalizada por horarios sin costo",
  "Entrega y recepción deben ser supervisadas por dueños de obras",
  "DJ Sets & eventos especiales por invitación",
  "Resguardo de 5 días tras el mes",
];

const HomeContent = () => {
  return (
    <>
      <video autoPlay loop muted playsInline className="video-background">
        <source src={HomeVideo} type="video/mp4" />
      </video>
    </>
  );
};

const EdicionesContent = () => {
  const ediciones = [
    { id: 1, img: "/IMG1-EDICIONES.jpeg" },
    { id: 2, img: "/IMG2-EDICIONES.jpeg" },
    { id: 3, img: "/IMG3-EDICIONES.jpeg", hide: true },
  ];
  return (
    <div className="scrollable-content">
      <video autoPlay loop muted playsInline className="video-background">
        <source src="/VID1-EDICIONESFONDO.mp4" type="video/mp4" />
      </video>
      <main className="content-section ediciones-section">
        {ediciones.map((item) => (
          <div key={item.id} className={`card ${item.id === 2 || item.hide ? "hide-mobile" : ""}`}>
            <img src={item.img} alt={`Edición ${item.id}`} className="promoimg" loading="lazy" />
          </div>
        ))}
      </main>
    </div>
  );
};

const ArtistasContent = () => (
  <div className="scrollable-content">
    <video autoPlay loop muted playsInline className="video-background">
      <source src={HomeVideo} type="video/mp4" />
    </video>
    <main className="content-section">
      <div className="info-card">
        {itemsArtistas.map((item, i) => (
          <p key={i}>{item}</p>
        ))}
      </div>
    </main>
  </div>
);

const SponsorsContent = () => (
  <>
    <video autoPlay loop muted playsInline className="video-background">
      <source src={HomeVideo} type="video/mp4" />
    </video>
    <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 10 }}>
      <a href="https://wa.me/525574413913" target="_blank" rel="noopener noreferrer" style={{
        color: 'white', fontSize: '1rem', display: 'flex', alignItems: 'center', gap: '10px',
        border: '1px solid rgba(0,0,0,0.5)', padding: '12px 24px', borderRadius: '8px',
        textDecoration: 'none', backdropFilter: 'blur(8px)', letterSpacing: '2px',
        backgroundColor: 'rgba(0,0,0,0.3)',
      }}>
        <Phone size={24} color="white" />
      </a>
    </div>
  </>
);

const RegistroContent = () => {
  const [form, setForm] = useState({
    nombre: "", apellidos: "", estado: "", edad: "",
    porQueReina: "", curriculum: null, acepto: false,
  });
  const [enviado, setEnviado]   = useState(false);
  const [error, setError]       = useState(false);
  const [enviando, setEnviando] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === "file")          setForm((p) => ({ ...p, [name]: files[0] || null }));
    else if (type === "checkbox") setForm((p) => ({ ...p, [name]: checked }));
    else                          setForm((p) => ({ ...p, [name]: value }));
  };

  const handleSubmit = async () => {
    const req = ["nombre", "apellidos", "estado", "edad"];
    const missing = req.some((k) => !form[k].toString().trim());
    if (missing || !form.acepto) { setError(true); return; }
    setError(false);
    setEnviando(true);

    try {
      const data = new FormData();
      data.append("nombre",        form.nombre);
      data.append("apellidos",     form.apellidos);
      data.append("estado",        form.estado);
      data.append("numeroDeObras", form.edad);
      data.append("sobreTi",       form.porQueReina || "No especificado");
      if (form.curriculum) data.append("comprobante", form.curriculum);

      const res = await fetch("https://theaggallery.com/api/registro", {
        method: "POST",
        body: data,
      });

      if (res.ok) setEnviado(true);
      else        setError(true);
    } catch (err) {
      console.error("Error al enviar:", err);
      setError(true);
    } finally {
      setEnviando(false);
    }
  };

  if (enviado) {
  return (
    <div className="scrollable-content">
      <video autoPlay loop muted playsInline className="video-background">
        <source src={HomeVideo} type="video/mp4" />
      </video>
      <main className="content-section registro-section">
        <p style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>✓</p>
        <p style={{ color: "#ccc" }}>Nos pondremos en contacto contigo pronto para confirmar tu participación.</p>
      </main>
    </div>
  );
}

  return (
    <div className="scrollable-content">
      <video autoPlay loop muted playsInline className="video-background">
  <source src={HomeVideo} type="video/mp4" />
</video>
      <div className="registro-spacer" />
      <main className="content-section registro-section">
        <div className="registro-card">
          <h2 className="registro-titulo">REGÍSTRATE</h2>
          <div className="registro-row">
            <div className="registro-field">
              <label className="registro-label">Nombre</label>
              <input className="form-input" name="nombre" value={form.nombre} onChange={handleChange} />
            </div>
            <div className="registro-field">
              <label className="registro-label">Apellidos</label>
              <input className="form-input" name="apellidos" value={form.apellidos} onChange={handleChange} />
            </div>
          </div>
          <div className="registro-row">
            <div className="registro-field">
              <label className="registro-label">Estado</label>
              <input className="form-input" name="estado" value={form.estado} onChange={handleChange} />
            </div>
            <div className="registro-field">
              <label className="registro-label">Numero de obras</label>
              <input className="form-input" name="edad" type="number" min="1" value={form.edad} onChange={handleChange} />
            </div>
          </div>
          <div className="registro-field">
            <label className="registro-label">Cuentanos un poco sobre ti</label>
            <textarea className="form-input" name="porQueReina" rows={4} value={form.porQueReina} onChange={handleChange} />
          </div>
          <div className="registro-field">
            <label className="registro-label">Adjuntar comprobante de pago</label>
            <div className="contenedor-horizontal-ajustado">
              <label className="file-btn">
                Seleccionar archivo
                <input type="file" name="curriculum" accept=".pdf,.doc,.docx,.png,.jpg,.jpeg" onChange={handleChange} hidden />
              </label>
              <label className="registro-check">
                <input type="checkbox" name="acepto" onChange={handleChange} />
                <span>Acepto los términos y condiciones</span>
              </label>
            </div>
            {form.curriculum && (
              <span style={{ color: '#FFFFFF', fontSize: '12px', display: 'block', marginTop: '5px' }}>
                {form.curriculum.name}
              </span>
            )}
          </div>
          {error && (
            <p className="registro-error">
              Por favor completa todos los campos obligatorios y acepta las condiciones.
            </p>
          )}
          <button className="registro-btn" onClick={handleSubmit} disabled={enviando}>
            {enviando ? "Enviando..." : "Enviar registro"}
          </button>
        </div>
      </main>
    </div>
  );
};

const routes = {
  home: "/", ediciones: "/ediciones", artistas: "/artistas",
  sponsors: "/sponsors", registro: "/registro",
};

const pageFromPath = {
  "/": "home", "/ediciones": "ediciones", "/artistas": "artistas",
  "/sponsors": "sponsors", "/registro": "registro", "/registro/": "registro",
};

const App = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activePage, setActivePage] = useState(pageFromPath[location.pathname] || "home");
  const [isOpen, setIsOpen]         = useState(false);
  const [scrolled, setScrolled]     = useState(false);

  useEffect(() => {
    setScrolled(false);
    const el = document.querySelector(".scrollable-content");
    if (!el) return;
    const onScroll = () => setScrolled(el.scrollTop > 50);
    el.addEventListener("scroll", onScroll, { passive: true });
    return () => el.removeEventListener("scroll", onScroll);
  }, [activePage]);

  useEffect(() => {
    if (isOpen || activePage === "home") {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    }
  }, [isOpen, activePage]);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.querySelectorAll(".scrollable-content").forEach((c) => { c.scrollTop = 0; });
  }, [activePage]);

  const menuOptions = [
    { name: "Inicio",    page: "home" },
    { name: "Ediciones", page: "ediciones" },
    { name: "Artistas",  page: "artistas" },
    { name: "Sponsors",  page: "sponsors" },
  ];

  const goTo = (page) => {
  setActivePage(page);
  setIsOpen(false);
  window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  navigate(routes[page]);
  };

  return (
    <>
      <header className={`main-header ${scrolled ? "scrolled" : ""}`}>
        <button onClick={() => setIsOpen(!isOpen)} className={`hamburger-btn ${isOpen ? "menu-open" : ""}`}>
          {isOpen ? <X size={30} color="white" /> : <Menu size={30} color="white" />}
        </button>
        {activePage === "home" && <img src={image4} alt="AG Gallery Logo" className="header-img" />}
      </header>

      <div className={`sidebar-overlay ${isOpen ? "visible" : ""}`} onClick={() => setIsOpen(false)} />

      <aside className={`sidebar ${isOpen ? "open" : ""}`}>
        <nav className="nav-links">
          {menuOptions.map((opt) => (
            <button key={opt.page} className={`nav-item ${activePage === opt.page ? "active" : ""}`} onClick={() => goTo(opt.page)}>
              {opt.name}
            </button>
          ))}
          <button className={`nav-item ${activePage === "registro" ? "active" : ""}`} onClick={() => goTo("registro")}>
            REGÍSTRATE
          </button>
          <button className="nav-item" onClick={() => window.open("https://www.instagram.com/aggallerymx", "_blank")}>
            INSTAGRAM
          </button>
        </nav>
        <div className="contact-icons">
          <a href="mailto:info@theaggallery.com" className="contact-link">
            <Mail size={18} color="white" />
          </a>
        </div>
      </aside>

      {activePage === "home"      && <HomeContent />}
      {activePage === "ediciones" && <EdicionesContent />}
      {activePage === "artistas"  && <ArtistasContent />}
      {activePage === "sponsors"  && <SponsorsContent />}
      {activePage === "registro"  && <RegistroContent />}

      {activePage === "home" && (
        <footer className="footer-black"><p>The AG Gallery - México</p></footer>
      )}
    </>
  );
};

export default App;